import { EventViewData } from 'components/eventView/pages/eventData';

export const BenatskaEvent: EventViewData = {
    eventId: 'benatska',
    mapId: '7bb39c48-4d8b-4caf-96f3-b972d31aac2d',
    guideId: 'f57f331a-255a-46d8-9635-f38eb7ad5c04',
    eventInfo: {
        program: {
            dateExtensionHours: 8,
            items: [
                {
                    programId: '953f3208-2482-4240-bf5d-fd3a9a95fc1f',
                    title: 'Pjena',
                    startDateTime: '2023-07-27T17:00:00.000Z',
                    endDateTime: '2023-07-27T17:45:00.000Z',
                    placeName: 'Impuls Stage',
                    storyIds: ['798114f0-c598-4d48-a324-409e53a8861d'],
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '69d0eaa0-2919-4815-ad9e-56e68cfacd24',
                    title: 'Kohout plaší smrt',
                    startDateTime: '2023-07-27T18:15:00.000Z',
                    endDateTime: '2023-07-27T19:15:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'db2df3de-87cf-4c30-a1da-5de694f7042f',
                    title: 'Ovčie Kiahně',
                    startDateTime: '2023-07-27T19:45:00.000Z',
                    endDateTime: '2023-07-27T20:45:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'efd52f25-8f62-4415-a156-a70da3ca39c1',
                    title: 'SPS',
                    startDateTime: '2023-07-27T21:15:00.000Z',
                    endDateTime: '2023-07-27T22:15:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'f6d34341-5892-4bab-97a2-78a77a69d4d0',
                    title: 'Lety mimo',
                    startDateTime: '2023-07-27T22:45:00.000Z',
                    endDateTime: '2023-07-27T23:45:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '55344948-c4b7-43fe-913f-e5c3b8203064',
                    title: 'Český mejdan s Impulsem – DJ Jirka Pošík',
                    startDateTime: '2023-07-28T00:15:00.000Z',
                    endDateTime: '2023-07-28T04:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'e549cda6-9bbd-44fc-87b8-52436c9ae72a',
                    title: 'Doctor P.P.',
                    startDateTime: '2023-07-28T17:00:00.000Z',
                    endDateTime: '2023-07-28T18:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '23017bca-ff51-45b2-9e85-aac71fb5901f',
                    title: 'Rozálie Havelková',
                    startDateTime: '2023-07-28T18:30:00.000Z',
                    endDateTime: '2023-07-28T19:30:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'dc5b972c-02d5-4957-91f3-f5c57511001f',
                    title: 'Cold Licks',
                    startDateTime: '2023-07-28T20:00:00.000Z',
                    endDateTime: '2023-07-28T21:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '161df381-d267-4bfc-a886-9cf9dea5ea0a',
                    title: 'Sebastian',
                    startDateTime: '2023-07-28T21:30:00.000Z',
                    endDateTime: '2023-07-28T22:30:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '3b35fba3-0e42-4a08-8799-1edd45f07c7c',
                    title: 'Katarina Knechtová',
                    startDateTime: '2023-07-28T23:00:00.000Z',
                    endDateTime: '2023-07-29T00:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'cac80032-539e-4383-95b2-ab251e41a869',
                    title: 'Český mejdan s Impulsem – DJ Jirka Pošík',
                    startDateTime: '2023-07-29T00:30:00.000Z',
                    endDateTime: '2023-07-29T04:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '5a5daecb-5a7e-4abf-bfe1-05e245547c0a',
                    title: 'Zpívánky pro děti',
                    startDateTime: '2023-07-29T13:00:00.000Z',
                    endDateTime: '2023-07-29T14:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'ce778d1c-be29-4dc7-962e-6014633bc041',
                    title: 'AZ-Kvíz',
                    startDateTime: '2023-07-29T13:00:00.000Z',
                    endDateTime: '2023-07-29T14:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'ea0a827c-87cc-4031-a431-e75fbeeaee08',
                    title: 'Těla',
                    startDateTime: '2023-07-29T15:00:00.000Z',
                    endDateTime: '2023-07-29T16:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'da75c2cc-7acd-41e3-bd45-7daba6a85a98',
                    title: 'Michal Penk',
                    startDateTime: '2023-07-29T18:30:00.000Z',
                    endDateTime: '2023-07-29T19:30:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '232f2b0c-c699-4c97-8c6d-e1aac0bbad83',
                    title: 'Ivan Hlas trio',
                    startDateTime: '2023-07-29T20:00:00.000Z',
                    endDateTime: '2023-07-29T21:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: 'f80a8b26-ae3e-43ff-8429-0d7d1668f9a5',
                    title: 'České Srdce',
                    startDateTime: '2023-07-29T21:30:00.000Z',
                    endDateTime: '2023-07-29T22:30:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '0469febc-cf86-4bfb-bd0c-1cc7ceb6c749',
                    title: 'Votchi',
                    startDateTime: '2023-07-29T23:00:00.000Z',
                    endDateTime: '2023-07-30T00:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },
                {
                    programId: '7d29d0b3-e1e0-47e3-80fb-d34a6bae4b7b',
                    title: 'Zpívánky pro děti',
                    startDateTime: '2023-07-30T00:30:00.000Z',
                    endDateTime: '2023-07-30T04:00:00.000Z',
                    placeName: 'Impuls Stage',
                    markerId: 'c865e019-f8f8-4f06-9094-9641d208a829'
                },

                {
                    programId: 'a8206ec4-046f-40e0-8145-70a723d0a1df',
                    startDateTime: '2023-07-27T17:00:00.000Z',
                    endDateTime: '2023-07-27T18:00:00.000Z',
                    title: 'Vašo Patejdl& Band',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'c0446b79-3cc7-4649-bc56-07417e4e7c1f',
                    startDateTime: '2023-07-27T18:30:00.000Z',
                    endDateTime: '2023-07-27T19:30:00.000Z',
                    title: 'Peter Nagy& Indigo',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '89f333b3-ce3a-4acb-90fc-f2a2e9b7d127',
                    startDateTime: '2023-07-27T20:00:00.000Z',
                    endDateTime: '2023-07-27T21:10:00.000Z',
                    title: 'Richard Müller',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '7194833d-b796-417e-8629-899908dfb613',
                    startDateTime: '2023-07-27T21:40:00.000Z',
                    endDateTime: '2023-07-27T22:40:00.000Z',
                    title: 'No Name',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '89a29b94-a528-4f18-9ba4-3031056350b5',
                    startDateTime: '2023-07-27T23:10:00.000Z',
                    endDateTime: '2023-07-28T00:10:00.000Z',
                    title: 'Brutus',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },

                {
                    programId: '0bff7527-07f2-4dc3-9379-0e8ecb28bd53',
                    startDateTime: '2023-07-28T14:30:00.000Z',
                    endDateTime: '2023-07-28T15:30:00.000Z',
                    title: 'Turbo',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'f5694b07-8001-4e8f-bbf2-dd38f1b3a96e',
                    startDateTime: '2023-07-28T16:00:00.000Z',
                    endDateTime: '2023-07-28T17:00:00.000Z',
                    title: 'Mňága a Žďorp',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '4662a6a4-21fb-4683-9e96-e8122e693c77',
                    startDateTime: '2023-07-28T17:30:00.000Z',
                    endDateTime: '2023-07-28T18.30:00.000Z',
                    title: 'Harlej',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '01fb82ea-9271-4385-8c49-e1c947a256e2',
                    startDateTime: '2023-07-28T19:00:00.000Z',
                    endDateTime: '2023-07-28T20:00:00.000Z',
                    title: 'Mirai',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '38fb7457-1844-4a71-b01d-83c6f719dc60',
                    startDateTime: '2023-07-28T20:45:00.000Z',
                    endDateTime: '2023-07-28T22:15:00.000Z',
                    title: 'Chris Norman& Band',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'a92a7c15-e0a6-4c62-beca-c706b5e71748',
                    startDateTime: '2023-07-28T23:00:00.000Z',
                    endDateTime: '2023-07-29T00:10:00.000Z',
                    title: 'Rybičky 48',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'caf38e67-a849-41fd-8418-40274a514a54',
                    startDateTime: '2023-07-29T00:40:00.000Z',
                    endDateTime: '2023-07-29T01:40:00.000Z',
                    title: 'Metalinda',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },

                {
                    programId: '51326b99-e9a3-4f99-8f81-7a49fa42e5e2',
                    startDateTime: '2023-07-29T13:00:00.000Z',
                    endDateTime: '2023-07-29T13:50:00.000Z',
                    title: 'BigOBand',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '46f0d09b-050b-438e-90ae-62c52279361c',
                    startDateTime: '2023-07-29T14:20:00.000Z',
                    endDateTime: '2023-07-29T15:10:00.000Z',
                    title: 'Poletíme?',
                    placeName: 'ČEZ Energy Stage',
                    storyIds: ['c1fe9032-4550-4b72-ae05-7734b953ccf4'],
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'dccd7549-e401-4ec8-815e-84d112503a2b',
                    startDateTime: '2023-07-29T15:40:00.000Z',
                    endDateTime: '2023-07-29T16:40:00.000Z',
                    title: 'Horkýže Slíže',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '7f76c7e0-b4b2-41fd-823b-52bb941530f8',
                    startDateTime: '2023-07-29T17:10:00.000Z',
                    endDateTime: '2023-07-29T18:10:00.000Z',
                    title: 'Kamil Střihavka',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '687f8536-d6b7-4500-bf9b-3241f60f75e1',
                    startDateTime: '2023-07-29T18:40:00.000Z',
                    endDateTime: '2023-07-29T19:40:00.000Z',
                    title: 'Lenka Filipová',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '3012e8be-e0c3-486b-8191-cfbe18afb345',
                    startDateTime: '2023-07-29T20:10:00.000Z',
                    endDateTime: '2023-07-29T21:50:00.000Z',
                    title: 'Jaromír Nohavica',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '8ac0ab71-fbd5-47c9-b7cf-7eb18f0d97ed',
                    startDateTime: '2023-07-29T22:20:00.000Z',
                    endDateTime: '2023-07-29T23:30:00.000Z',
                    title: 'David Koller',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: '78bb9043-83ed-4cf5-ae8e-cd54d9807b85',
                    startDateTime: '2023-07-30T00:00:00.000Z',
                    endDateTime: '2023-07-30T01:00:00.000Z',
                    title: 'Děda Mládek I.B.',
                    placeName: 'ČEZ Energy Stage',
                    markerId: '75bfb244-37b1-4d00-898e-35924669e4c7'
                },
                {
                    programId: 'af14e1b4-bcc5-47f4-98e1-1fc033f138cb',
                    startDateTime: '2023-07-28T14:30:00.000Z',
                    endDateTime: '2023-07-28T15:15:00.000Z',
                    title: 'Alchymie',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '2d7cfd35-9a9b-4048-98bc-4d52c96ea735',
                    startDateTime: '2023-07-28T15:45:00.000Z',
                    endDateTime: '2023-07-28T16:30:00.000Z',
                    title: 'Loretta',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '459c0845-6dff-4dfd-897e-38f526c2b509',
                    startDateTime: '2023-07-28T17:00:00.000Z',
                    endDateTime: '2023-07-28T18:00:00.000Z',
                    title: 'Portless',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '5f9df3e1-54a7-4521-9b06-d2016f9d54ec',
                    startDateTime: '2023-07-28T18:30:00.000Z',
                    endDateTime: '2023-07-28T19:30:00.000Z',
                    title: 'Trautenberk',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '92ff8c7a-47d3-482a-a8ef-1b7d430d835b',
                    startDateTime: '2023-07-28T20:00:00.000Z',
                    endDateTime: '2023-07-28T21:00:00.000Z',
                    title: 'Krucipüsk',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '586f8ed1-d7f8-4281-b409-426d5f9f03a5',
                    startDateTime: '2023-07-28T21:30:00.000Z',
                    endDateTime: '2023-07-28T22:30:00.000Z',
                    title: 'Doga',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: 'efea51aa-d4f4-47b7-a4ef-01d81b1dd7a5',
                    startDateTime: '2023-07-28T23:00:00.000Z',
                    endDateTime: '2023-07-29T00:00:00.000Z',
                    title: 'De Bill Heads',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '5628466c-00d8-473a-902f-e8e1e32a38cd',
                    startDateTime: '2023-07-29T00:30:00.000Z',
                    endDateTime: '2023-07-29T01:30:00.000Z',
                    title: 'Škaredá holka',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '38c69ab2-41a5-4158-b7c3-301148788cc9',
                    startDateTime: '2023-07-29T13:30:00.000Z',
                    endDateTime: '2023-07-29T14:15:00.000Z',
                    title: 'Alocation',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '666e3108-2f34-461d-92de-0e7151ae2eb0',
                    startDateTime: '2023-07-29T14:45:00.000Z',
                    endDateTime: '2023-07-29T15:30:00.000Z',
                    title: 'Robin Mood',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '8c4bd648-ca82-4348-9d9e-0c6111730f7e',
                    startDateTime: '2023-07-29T16:00:00.000Z',
                    endDateTime: '2023-07-29T16:45:00.000Z',
                    title: 'Eliška Rusková',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '619bfa27-a1b4-40b5-a823-63e6f0ed0eaf',
                    startDateTime: '2023-07-29T17:00:00.000Z',
                    endDateTime: '2023-07-29T17:30:00.000Z',
                    title: 'Šimon Mikez',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '46ed9f27-9c71-44de-a7cc-e4dec69c9bdb',
                    startDateTime: '2023-07-29T17:50:00.000Z',
                    endDateTime: '2023-07-29T18:40:00.000Z',
                    title: 'Sharlota',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '4572068c-804d-4224-abb2-bb28f8eb7da9',
                    startDateTime: '2023-07-29T19:10:00.000Z',
                    endDateTime: '2023-07-29T20:10:00.000Z',
                    title: 'Paulie Garand',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '0348b8be-8995-4ff1-be18-73f51f23c08d',
                    startDateTime: '2023-07-29T21:50:00.000Z',
                    endDateTime: '2023-07-29T22:50:00.000Z',
                    title: 'Viktor Sheen',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: 'cbb642c7-3278-4997-994e-1d88079d69d2',
                    startDateTime: '2023-07-29T23:20:00.000Z',
                    endDateTime: '2023-07-30T00:20:00.000Z',
                    title: 'Yzomandias',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                },
                {
                    programId: '4914ce4b-abd0-4235-be3b-d04cf2fb95d1',
                    startDateTime: '2023-07-30T00:50:00.000Z',
                    endDateTime: '2023-07-30T01:50:00.000Z',
                    title: 'Marpo& TroubleGang',
                    placeName: 'Adifex Stage',
                    markerId: '5f3c68b4-7fc7-4db3-8899-0735aa2363d1'
                }
            ]
        }
    }
};
